import {
	ConfluencePageAri,
	JiraIssueAri,
	TownsquareGoalAri,
	TownsquareProjectAri,
	IdentityTeamAri,
} from '@atlassian/ari';

import { GlobalObjectType } from '@atlassian/preview-panel-global-objects';

export const ALL_SUPPORTED_OBJECTS: GlobalObjectType[] = [
	'jira-issue',
	'confluence-page',
	'identity-team',
	'townsquare-goal',
	'townsquare-project',
];

export const isPreviewPanelAvailable = ({ ari }: { ari: string }) =>
	ConfluencePageAri.check(ari) ||
	JiraIssueAri.check(ari) ||
	TownsquareGoalAri.check(ari) ||
	TownsquareProjectAri.check(ari) ||
	IdentityTeamAri.check(ari);
